var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricHookUpCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Electric_hook_up_-_Coral"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 31.384,
    y1: 66.161,
    x2: 62.983,
    y2: 34.562
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M35.149,62.395 l16.729,16.729c2.672,2.672,7.004,2.672,9.676,0l8.221-8.221l11.25,11.25c2.347,2.347,6.153,2.347,8.5,0l4.223-4.223 c2.347-2.347,6.153-2.347,8.5,0l0,0c2.347,2.347,2.347,6.153,0,8.5L99.8,88.879c-2.347,2.347-2.347,6.153,0,8.5l3.917,3.917"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M59.649,37.895 l16.973,16.662c2.714,2.664,2.734,7.031,0.045,9.721l0,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 40.233,
    y1: 56.312,
    x2: 27.55,
    y2: 43.629
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 53.45,
    y1: 42.946,
    x2: 40.768,
    y2: 30.263
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricHookUpCoral);
export default __webpack_public_path__ + "static/media/Electric Hook Up - Coral.98e1d4c304a2ca3348d3694e7fb09aa8.svg";
export { ForwardRef as ReactComponent };